import { Injectable } from '@angular/core';
import { ClientEvideForm, IClientEvideFormHttp, IClientEvideFormSaveAnswerHttp } from 'client/models';
import { GetCaptchaInfo, IGetCaptchaInfo } from 'client/models/form/captcha.model';
import { AppHttpClient } from 'common/service/app-http-client.service';
import { Observable, map } from 'rxjs';

import { prepareClientFormApiUrl } from '../app.const';
import { IExecuteRuleRequest, IExecuteRule } from 'common/model';
import { ExecuteRuleService } from 'shared/execute-rule.service';

const HttpServiceMethods = {
  getClientFormInfoUrlUrl: (formGuid: string) => prepareClientFormApiUrl(`GetEvideInputContentFormBuilderInfoByGuid/${formGuid}`),
  getClientFormInfoUrl: () => prepareClientFormApiUrl(``),
  saveClientFormAnswerUrl: () => prepareClientFormApiUrl('SaveClientEvideFormAnswer'),
  getCaptchaInfoUrl: () => prepareClientFormApiUrl('GetCaptchaInfo'),
  getExecuteRuleUrl: () => prepareClientFormApiUrl('ExecuteRule'),
  generateContactReferenceUrl: () => prepareClientFormApiUrl('GenerateContactReference')
};
@Injectable()
export class ClientEvideFormService {

  constructor(private httpService: AppHttpClient, private executeRuleService: ExecuteRuleService) { }

  public getClientFormInfoFormGuid(formGuid: string): Observable<ClientEvideForm> {
    return this.httpService
      .get<IClientEvideFormHttp>(HttpServiceMethods.getClientFormInfoUrlUrl(formGuid))
      .pipe(map((item) => ClientEvideForm.fromJson(item)));
  }

  public getClientFormInfo(): Observable<ClientEvideForm> {
    return this.httpService
      .get<IClientEvideFormHttp>(HttpServiceMethods.getClientFormInfoUrl())
      .pipe(map((item) => ClientEvideForm.fromJson(item)));
  }

  public saveClientFormAnswer(body: IClientEvideFormSaveAnswerHttp
  ): Observable<{ message: string }> {
    return this.httpService.post<{ message: string }>(HttpServiceMethods.saveClientFormAnswerUrl(), body);
  }

  public getCaptchaInfo(): Observable<GetCaptchaInfo> {
    return this.httpService
      .get<IGetCaptchaInfo>(HttpServiceMethods.getCaptchaInfoUrl())
      .pipe(map((item) => GetCaptchaInfo.fromJson(item)));
  }

  public executeRule(body: IExecuteRuleRequest): Observable<IExecuteRule> {
    return this.executeRuleService.executeRule(body);
  }

  // Reference generator — the client web form pre-fills the (editable) reference field with the provisional
  // next value on open; the real gap-free reference is assigned on submit.
  public generateContactReference(): Observable<string> {
    return this.httpService
      .get<{ reference: string; provisional: boolean }>(HttpServiceMethods.generateContactReferenceUrl())
      .pipe(map((res) => res?.reference ?? ''));
  }
}
